module.exports = __webpack_public_path__ + "img/top4.J.d09bea11.png";